import React from 'react'
import { CustomEmbeddedCode, CustomEmbeddedCodeProps } from '@classy/campaign-page-blocks'
import { logger } from 'utils/logger'

/**
 * Client-side wrapper for the CustomEmbeddedCode block.
 *
 * ! Future devs: it is important to prevent any reactivity in this component.
 * ! This component is rendered once when the page loads, and should not re-render.
 * ! Re-renders will cause the iframe to reload, which is not desired.
 */
export const CustomEmbeddedCodeController = ({
  dataIframeId,
  ...rest
}: CustomEmbeddedCodeProps) => {
  if (!dataIframeId) {
    logger('error', 'CustomEmbeddedCode: dataIframeId is required but not provided')
    return null
  }

  return (
    <CustomEmbeddedCode
      {...rest}
      dataIframeId={dataIframeId}
      /**
       * In the SDK, when the READY_SIGNAL is received, it auto-resizes the iframe's height.
       * overflow:clip hides the scrollbar, and transition animates height changes.
       */
      style={{
        overflow: 'clip',
        transition: 'height 0.1s ease-in',
      }}
    />
  )
}
